// // ✅ Fixed base (no more unit selection / no localStorage baseURL)
// export const BASE_URL = {
//   BASE: "https://shahi-knits.smartekanban.in",
//   API_ROOT: "/index.php/apiv7",
//   API_ROOT_SIX: "/index.php/apiv6",
//   API_ROOT_EIGHT: "/index.php/apiv8",
// };

// // ✅ Portal API (to fetch unit_code by @unitX)
// export const PORTAL_API = {
//   BASE: "https://portals.smartekanban.in",
//   API_ROOT: "/index.php/Apiv1",
// };

// // ✅ Build API base for a unit_code
// export const getUnitApiBase = (unitCode) => {
//   return `${BASE_URL.BASE}${BASE_URL.API_ROOT}/${unitCode}`;
// };

// // ✅ v6 unit-based
// export const getApiBaseSix = () => {
//   return `${BASE_URL.BASE}${BASE_URL.API_ROOT_SIX}`;
// };

// // ✅ v8 unit-based
// export const getApiBaseEight = () => {
//   return `${BASE_URL.BASE}${BASE_URL.API_ROOT_EIGHT}`;
// };

// // ✅ portal endpoints
// export const PORTAL_URL = {
//   get_units_for_webapp: "/get_shahi_units_for_webapp",
// };

// const SUB_URL = {
//   login_webapp: "/user_login_for_webapp",
//   get_kanban_data: "/get_kanban_details",
//   login: "/sorting_user_login",
//   add_eol_dispatch: "/add_eol_dispatch",
//   get_dashboard_data: "/get_dashboard_data",
//   getLine: "/get_lines",
//   get_item_no: "/get_item_no",
//   get_po_by_item: "/get_purchase_orders",
//   get_color: "/get_colors",
//   get_eol_report: "/eol_dispatch_report",
//   display_active_kanban: "/display_active_kanban",
//   add_bin: "/add_bin",
//   get_bins: "/get_bins",
//   view_bin: "/view_bin",
//   deleteKanbanByDbdid: "/delete_kanban_bydbdid",
//   editKanban: "/edit_kanban_bydbdid",
//   add_garment: "/add_garment_details",
//   add_garments: "/add_garments",
//   getMaster_get_bins_details: "/get_bins_details",
//   get_inward_outward_report: "/inward_outward_report",
//   Kanban_Count_accuracy: "/Kanban_Count_accuracy",
//   scan_barcode: "/scan_barcode",
// };

// const SUB_URL_wash = {
//   view_bin: "/view_bin",
//   outward: "/washing_bin_outward",
//   in_ward: "/washing_bin_inward",
//   washing: "/send_bin_to_washing",
// };

// const SUB_URL_GSM = {
//   GSM_inward: "/garment_supermarket_inward",
//   getGSMBin: "/get_gsm_bins",
//   GSM_outward: "/garment_supermarket_outward",
// };

// const SUB_URL_dispatch_center = {
//   bin_bulk_outward: "/send_bulk_bin_to_washing",
//   getBinByBinId: "/get_dispatch_bin",
//   getBulkBindata: "/get_bulk_bins_details",
// };

// const SUB_URL_KCA = {
//   get_kca_daily_report: "/get_kca_daily_report",
// };

// const SUB_URL_Checker = {
//   prepare_eol_screen: "/prepare_eol_screen",
//   get_userline_and_items: "/get_userline_and_items",
//   get_inline_parts: "/get_inline_parts",
//   get_inline_defect_reason: "/get_inline_defect_reason",
//   get_inline_operations: "/get_inline_operations",
// };

// const SUB_URL_KanbanPlanSheet = {
//   get_active_items: "/get_active_items",
//   get_style_no_by_item_no: "/get_style_no_by_item_no",
//   get_po_no_by_style_no: "/get_po_no_by_style_no",
//   get_color_by_po_no: "/get_color_by_po_no",
//   get_kanban_details_for_sorting: "/get_kanban_details_for_sorting",
//   set_sorting_one: "/set_sorting_one",
//   update_size_quantity: "/update_size_quantity",
// };

// export {
//   SUB_URL,
//   SUB_URL_wash,
//   SUB_URL_GSM,
//   SUB_URL_dispatch_center,
//   SUB_URL_KCA,
//   SUB_URL_Checker,
//   SUB_URL_KanbanPlanSheet,
// };

// ✅ Fixed base
export const BASE_URL = {
  BASE: "https://shahi-knits.smartekanban.in",
  API_ROOT: "/index.php/apiv7",
  API_ROOT_SIX: "/index.php/apiv6",
  API_ROOT_EIGHT: "/index.php/apiv8",
  API_ROOT_FOUR: "/index.php/apiv4",
};

// ✅ Portal API
export const PORTAL_API = {
  BASE: "https://portals.smartekanban.in",
  API_ROOT: "/index.php/Apiv1",
};

// ✅ apiv7 + unit_code
export const getUnitApiBase = (unitCode) => {
  return `${BASE_URL.BASE}${BASE_URL.API_ROOT}/${unitCode}`;
};

// ✅ apiv4 + unit_code
export const getUnitApiBaseFour = (unitCode) => {
  return `${BASE_URL.BASE}${BASE_URL.API_ROOT_FOUR}/${unitCode}`;
};

// ✅ v6
export const getApiBaseSix = () => {
  return `${BASE_URL.BASE}${BASE_URL.API_ROOT_SIX}`;
};

// ✅ v8
export const getApiBaseEight = () => {
  return `${BASE_URL.BASE}${BASE_URL.API_ROOT_EIGHT}`;
};

// ✅ portal endpoints
export const PORTAL_URL = {
  get_units_for_webapp: "/get_shahi_units_for_webapp",
};

const SUB_URL = {
  login_webapp: "/user_login_for_webapp",
  get_kanban_data: "/get_kanban_details",
  login: "/sorting_user_login",
  add_eol_dispatch: "/add_eol_dispatch",
  get_dashboard_data: "/get_dashboard_data",
  getLine: "/get_lines",
  get_item_no: "/get_item_no",
  get_po_by_item: "/get_purchase_orders",
  get_color: "/get_colors",
  get_eol_report: "/eol_dispatch_report",
  display_active_kanban: "/display_active_kanban",
  add_bin: "/add_bin",
  get_bins: "/get_bins",
  view_bin: "/view_bin",
  deleteKanbanByDbdid: "/delete_kanban_bydbdid",
  editKanban: "/edit_kanban_bydbdid",
  add_garment: "/add_garment_details",
  add_garments: "/add_garments",
  getMaster_get_bins_details: "/get_bins_details",
  get_inward_outward_report: "/inward_outward_report",
  Kanban_Count_accuracy: "/Kanban_Count_accuracy",
  scan_barcode: "/scan_barcode",
  bulk_bin_movement: "/bulk_bin_movement",
  garment_supermarket_bulk_inward: "/garment_supermarket_bulk_inward",
  get_available_bins: "/get_available_bins",
  get_today_gsm_outward_total: "/get_today_gsm_outward_total",
};

const SUB_URL_wash = {
  view_bin: "/view_bin",
  outward: "/washing_bin_outward",
  in_ward: "/washing_bin_inward",
  washing: "/send_bin_to_washing",
  washing_dashboard_cards: "/washing_dashboard_cards",
};

const SUB_URL_GSM = {
  GSM_inward: "/garment_supermarket_inward",
  getGSMBin: "/get_gsm_bins",
  GSM_outward: "/garment_supermarket_outward",
};

const SUB_URL_dispatch_center = {
  bin_bulk_outward: "/send_bulk_bin_to_washing",
  getBinByBinId: "/get_dispatch_bin",
  getBulkBindata: "/get_bulk_bins_details",
};

const SUB_URL_KCA = {
   get_kca_daily_report: "/get_kca_daily_report",
  gsm_summary_total: "/gsm_summary_total",
};

const SUB_URL_Checker = {
  prepare_eol_screen: "/prepare_eol_screen",
  get_userline_and_items: "/get_userline_and_items",
  get_inline_parts: "/get_inline_parts",
  get_inline_defect_reason: "/get_inline_defect_reason",
  get_inline_operations: "/get_inline_operations",
};

const SUB_URL_KanbanPlanSheet = {
  get_active_items: "/get_active_items",
  get_style_no_by_item_no: "/get_style_no_by_item_no",
  get_po_no_by_style_no: "/get_po_no_by_style_no",
  get_color_by_po_no: "/get_color_by_po_no",
  get_kanban_details_for_sorting: "/get_kanban_details_for_sorting",
  set_sorting_one: "/set_sorting_one",
  update_size_quantity: "/update_size_quantity",
};
 const SUB_URL_BIN = {
  get_bin_movement: "/getBinMovement",
};


export {
  SUB_URL,
  SUB_URL_wash,
  SUB_URL_GSM,
  SUB_URL_dispatch_center,
  SUB_URL_KCA,
  SUB_URL_Checker,
  SUB_URL_KanbanPlanSheet,SUB_URL_BIN
};